import { UserAddOutlined } from '@ant-design/icons'
import { Button, Select, Typography } from 'antd'
import get from 'lodash.get'
import React, { useState } from 'react'
import { removeVietnameseTones } from '../../config-func'
import { requestManagerAdd } from '../../services/requestservice'
import openNotification from '../common/Notification/openNotification '
import styles from './styles.module.scss'
const { Option } = Select
const { Text } = Typography

const ManageRequest = ({
  setOpen,
  requestId,
  data = [],
  setSelectedRowKeys,
  fetchData
}) => {
  const [selectedManager, setSelectedManager] = useState(null)

  const handleAdd = async () => {
    try {
      const body = {
        ids: requestId,
        assigner_id: selectedManager
        // from: 2
      }
      const res = await requestManagerAdd(body)
      if (res?.data?.list) {
        openNotification('success', 'Thêm thành công quản lý yêu cầu')
        setOpen(false)
        setSelectedRowKeys([])
        fetchData()
        // getListUserRequest()
      } else {
        openNotification('error', 'Có lỗi xảy ra')
      }
    } catch (err) {
      const errors = get(err, 'response.data.message', [])
      const errorMessages = Array.isArray(errors)
        ? errors.map((error) => error.message).join('\n')
        : errors

      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setSelectedManager(null) // Reset giá trị Select sau khi gọi API
    }
  }

  return (
    <div className={styles.listManagePost}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: 20
        }}
      >
        <div>Thêm quản lý:</div>
        <Select
          style={{ width: '70%' }}
          placeholder="Chọn quản lý"
          value={selectedManager} // Gán value từ state
          onChange={(value) => setSelectedManager(value)}
          allowClear
          showSearch
          filterOption={(input, option) => {
            const inputValue = removeVietnameseTones(input).toLowerCase();
            const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
            return optionValue.includes(inputValue);
          }}
        >
          {data.map((item) => {
            return (
              <Option key={item.id} value={item.id}>
                {item.name}
              </Option>
            )
          })}
        </Select>

        <Button type="primary" icon={<UserAddOutlined />} onClick={handleAdd} />
      </div>
    </div>
  )
}

export default ManageRequest
